export const simActivationCsvFilter = (role, tile, content, tab) => {
  let tileName;
  if (tab === "CAF") {
    tileName = "pending";
  } else {
    tileName = "total";
  }
  let csv = content;
  ({
    ZD: () => {
      ({
        sim: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["ZD"] = obj["zd"] ?? "";
              obj["ZD Name"] = obj["zdName"] ?? "";
              obj["JC"] = obj["jcId"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["RDS"] = obj["rds"] ?? "";
              obj["RDS Name"] = obj["rdsName"] ?? "";
              obj["Retailer"] = obj["retailerId"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["Billing Type"] = obj["billingTypeText"] ?? "";
              obj["MNP"] = obj["mnpFlag"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["Offer Code"] = obj["offerCode"] ?? "";
              obj["E-KYC"] = obj["ekycFlag"] ?? "";
              obj["Plan"] = obj["tarQty"] ?? "";
              obj["Quantity"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["billingTypeText"];
              delete obj["mnpFlag"];
              delete obj["posAgentCode"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["offerCode"];
              delete obj["offerCategory"];
              delete obj["ekycFlag"];
              delete obj["tarQty"];
              delete obj["qty"];
              delete obj["perAch"];
              delete obj["retailerId"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeName"];
              delete obj["ard"];
              delete obj["ardName"];
              return obj;
            });
          return csv;
        },
        daily: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Retailer Code"] = obj["retailerId"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Name"] = obj["posAgentName"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgentRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgentRoleTypeName"] ?? "";
              obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
              delete obj["retailerId"];
              delete obj["retailerName"];
              delete obj["posAgentCode"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["posAgentRoleTypeName"];
              delete obj["jprTypeName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["tarQty"];
              delete obj["rdsName"];
              delete obj["rdsId"];
              return obj;
            });
          return csv;
        },
        last: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["ZD Code"] = obj["zd"] ?? "";
              obj["ZD Name"] = obj["zdName"] ?? "";
              obj["RDS Code"] = obj["rds"] ?? "";
              obj["RDS Name"] = obj["rdsName"] ?? "";
              obj["Retailer Code"] = obj["retailerId"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Name"] = obj["posAgentName"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgentRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgentRoleTypeName"] ?? "";
              obj["Offer Category"] = obj["offerCategory"] ?? "";
              obj["Qty"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailerId"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["posAgentCode"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["posAgentRoleTypeName"];
              delete obj["offerCategory"];
              delete obj["qty"];
              delete obj["ard"];
              delete obj["ardName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["billingTypeText"];
              delete obj["offerCode"];
              delete obj["ekycFlag"];
              delete obj["mnpFlag"];
              delete obj["tarQty"];
              delete obj["perAch"];
              return obj;
            });
          return csv;
        },
        JIOPHONE: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["ZD"] = obj["zdCode"] ?? "";
              obj["ZD Name"] = obj["zdName"] ?? "";
              obj["JC"] = obj["jcCode"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["RDS"] = obj["rds"] ?? "";
              obj["RDS Name"] = obj["rdsName"] ?? "";
              obj["Retailer"] = obj["retailerId"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
              obj["Billing Type"] = obj["billingType"] ?? "";
              obj["MNP"] = obj["mnp"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgenRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgenRoleTypeName"] ?? "";
              obj["Offer Code"] = obj["offerCode"] ?? "";
              obj["Offer Category"] = obj["offerCategory"] ?? "";
              obj["E-KYC"] = obj["ekycFlag"] ?? "";
              obj["Plan"] = obj["plan"] ?? "";
              obj["Quantity"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zdCode"];
              delete obj["zdName"];
              delete obj["jcCode"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["billingType"];
              delete obj["mnp"];
              delete obj["posAgentCode"];
              delete obj["posAgenRoleTypeCode"];
              delete obj["posAgenRoleTypeName"];
              delete obj["offerCode"];
              delete obj["offerCategory"];
              delete obj["ekycFlag"];
              delete obj["plan"];
              delete obj["qty"];
              delete obj["perAch"];
              delete obj["retailerId"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeName"];
              delete obj["ard"];
              delete obj["ardName"];
              return obj;
            });
          return csv;
        },
      })[tile]();
      return csv;
    },
    CHAIN: () => {
      ({
        sim: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC"] = obj["jcId"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["CHAIN"] = obj["rds"] ?? "";
              obj["CHAIN Name"] = obj["rdsName"] ?? "";
              obj["Store ID"] = obj["retailerId"] ?? "";
              obj["Store Name"] = obj["retailerName"] ?? "";
              obj["Billing Type"] = obj["billingTypeText"] ?? "";
              obj["MNP"] = obj["mnpFlag"] ?? "";
              obj["Offer Code"] = obj["offerCode"] ?? "";
              obj["E-KYC"] = obj["ekycFlag"] ?? "";
              obj["Plan"] = obj["tarQty"] ?? "";
              obj["Quantity"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["billingTypeText"];
              delete obj["mnpFlag"];
              delete obj["posAgentCode"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["offerCode"];
              delete obj["offerCategory"];
              delete obj["ekycFlag"];
              delete obj["tarQty"];
              delete obj["qty"];
              delete obj["perAch"];
              delete obj["retailerId"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeName"];
              delete obj["ard"];
              delete obj["ardName"];
              return obj;
            });
          return csv;
        },
        daily: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Store Code"] = obj["retailerId"] ?? "";
              obj["Store Name"] = obj["retailerName"] ?? "";
              obj["JC Code"] = obj["jcId"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Name"] = obj["posAgentName"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgentRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgentRoleTypeName"] ?? "";
              delete obj["retailerId"];
              delete obj["retailerName"];
              delete obj["posAgentCode"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["posAgentRoleTypeName"];
              delete obj["jprTypeName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["tarQty"];
              delete obj["rdsName"];
              delete obj["rdsId"];
              return obj;
            });
          return csv;
        },
        last: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["CHAIN Code"] = obj["rds"] ?? "";
              obj["CHAIN Name"] = obj["rdsName"] ?? "";
              obj["Store Code"] = obj["retailerId"] ?? "";
              obj["Store Name"] = obj["retailerName"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Name"] = obj["posAgentName"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgentRoleTypeName"] ?? "";
              obj["Offer Category"] = obj["offerCategory"] ?? "";
              obj["Qty"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailerId"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["posAgentCode"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["posAgentRoleTypeName"];
              delete obj["offerCategory"];
              delete obj["qty"];
              delete obj["ard"];
              delete obj["ardName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["billingTypeText"];
              delete obj["offerCode"];
              delete obj["ekycFlag"];
              delete obj["mnpFlag"];
              delete obj["tarQty"];
              delete obj["perAch"];
              return obj;
            });
          return csv;
        },
        order: () => {
          tileName &&
            {
              total: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Distributor PRIM Id"] = obj["distPrmId"] ?? "";
                    obj["Distributor Name"] = obj["distPrmName"] ?? "";
                    obj["Retailer PRM Id"] = obj["retailerPrmId"] ?? "";
                    obj["Retailer Name"] = obj["retailerPrmName"] ?? "";
                    obj["JC Id"] = obj["jcId"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["JP Id"] = obj["jpId"] ?? "";
                    obj["JP Name"] = obj["jpName"] ?? "";
                    obj["MNP"] = obj["mnp"] ?? "";
                    obj["Order Count"] = obj["orderCnt"] ?? "";
                    delete obj["distPrmId"];
                    delete obj["distPrmName"];
                    delete obj["retailerPrmId"];
                    delete obj["retailerPrmName"];
                    delete obj["jcId"];
                    delete obj["jcName"];
                    delete obj["jpId"];
                    delete obj["jpName"];
                    delete obj["mnp"];
                    delete obj["orderCnt"];
                    delete obj["posAgentCode"];
                    delete obj["posAgentName"];
                    delete obj["orn"];
                    delete obj["cafNo"];
                    delete obj["aoRej"];
                    delete obj["aoRejMsg"];
                    delete obj["tvPending"];
                    delete obj["tvRejected"];
                    return obj;
                  });
                return csv;
              },
              pending: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Distributor PRIM Id"] = obj["distPrmId"] ?? "";
                    obj["Distributor Name"] = obj["distPrmName"] ?? "";
                    obj["Retailer PRM Id"] = obj["retailerPrmId"] ?? "";
                    obj["Retailer Name"] = obj["retailerPrmName"] ?? "";
                    obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
                    obj["POS Agent Name"] = obj["posAgentName"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["JP Id"] = obj["jpId"] ?? "";
                    obj["JP Name"] = obj["jpName"] ?? "";
                    obj["ORN"] = obj["orn"] ?? "";
                    obj["CAF number"] = obj["cafNo"] ?? "";
                    obj["AO Rejected"] = obj["aoRej"] ?? "";
                    obj["AO Rejected Message"] = obj["aoRejMsg"] ?? "";
                    obj["TV Pending"] = obj["tvPending"] ?? "";
                    obj["TV Rejected"] = obj["tvRejected"] ?? "";
                    delete obj["distPrmId"];
                    delete obj["distPrmName"];
                    delete obj["retailerPrmId"];
                    delete obj["retailerPrmName"];
                    delete obj["jcId"];
                    delete obj["jcName"];
                    delete obj["jpId"];
                    delete obj["jpName"];
                    delete obj["mnp"];
                    delete obj["orderCnt"];
                    delete obj["posAgentCode"];
                    delete obj["posAgentName"];
                    delete obj["orn"];
                    delete obj["cafNo"];
                    delete obj["aoRej"];
                    delete obj["aoRejMsg"];
                    delete obj["tvPending"];
                    delete obj["tvRejected"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
          return csv;
        },
        JIOPHONE: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["ZDMT"] = obj["zdCode"] ?? "";
              obj["ZDMT Name"] = obj["zdName"] ?? "";
              obj["JC"] = obj["jcCode"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["CHAIN"] = obj["rds"] ?? "";
              obj["CHAIN Name"] = obj["rdsName"] ?? "";
              obj["Store"] = obj["retailerId"] ?? "";
              obj["Store Name"] = obj["retailerName"] ?? "";
              obj["Billing Type"] = obj["billingType"] ?? "";
              obj["MNP"] = obj["mnp"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgenRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgenRoleTypeName"] ?? "";
              obj["Offer Code"] = obj["offerCode"] ?? "";
              obj["Offer Category"] = obj["offerCategory"] ?? "";
              obj["E-KYC"] = obj["ekycFlag"] ?? "";
              obj["Plan"] = obj["plan"] ?? "";
              obj["Quantity"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zdCode"];
              delete obj["zdName"];
              delete obj["jcCode"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["billingType"];
              delete obj["mnp"];
              delete obj["posAgentCode"];
              delete obj["posAgenRoleTypeCode"];
              delete obj["posAgenRoleTypeName"];
              delete obj["offerCode"];
              delete obj["offerCategory"];
              delete obj["ekycFlag"];
              delete obj["plan"];
              delete obj["qty"];
              delete obj["perAch"];
              delete obj["retailerId"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeName"];
              delete obj["ard"];
              delete obj["ardName"];
              return obj;
            });
          return csv;
        },
      })[tile]();
      return csv;
    },
    ARD: () => {
      ({
        sim: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC"] = obj["jcId"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["ARD"] = obj["ard"] ?? "";
              obj["ARD Name"] = obj["ardName"] ?? "";
              obj["Retailer"] = obj["retailerId"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["Billing Type"] = obj["billingTypeText"] ?? "";
              obj["MNP"] = obj["mnpFlag"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["Offer Code"] = obj["offerCode"] ?? "";
              obj["E-KYC"] = obj["ekycFlag"] ?? "";
              obj["Plan"] = obj["tarQty"] ?? "";
              obj["Quantity"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["billingTypeText"];
              delete obj["mnpFlag"];
              delete obj["posAgentCode"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["offerCode"];
              delete obj["offerCategory"];
              delete obj["ekycFlag"];
              delete obj["tarQty"];
              delete obj["qty"];
              delete obj["perAch"];
              delete obj["retailerId"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeName"];
              delete obj["ard"];
              delete obj["ardName"];
              return obj;
            });
        },
        daily: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["UAO/URO Code"] = obj["retailerId"] ?? "";
              obj["UAO/URO Name"] = obj["retailerName"] ?? "";
              obj["JC Code"] = obj["jcId"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Name"] = obj["posAgentName"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgentRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgentRoleTypeName"] ?? "";
              obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
              delete obj["retailerId"];
              delete obj["retailerName"];
              delete obj["posAgentCode"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["posAgentRoleTypeName"];
              delete obj["jprTypeName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["tarQty"];
              delete obj["rdsName"];
              delete obj["rdsId"];
              return obj;
            });
          return csv;
        },
        last: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["ARD Code"] = obj["ard"] ?? "";
              obj["ARD Name"] = obj["ardName"] ?? "";
              obj["UAO/URO Code"] = obj["retailerId"] ?? "";
              obj["UAO/URO Name"] = obj["retailerName"] ?? "";
              obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Name"] = obj["posAgentName"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgentRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgentRoleTypeName"] ?? "";
              obj["Offer Category"] = obj["offerCategory"] ?? "";
              obj["Qty"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailerId"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["posAgentCode"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["posAgentRoleTypeName"];
              delete obj["offerCategory"];
              delete obj["qty"];
              delete obj["ard"];
              delete obj["ardName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["billingTypeText"];
              delete obj["offerCode"];
              delete obj["ekycFlag"];
              delete obj["mnpFlag"];
              delete obj["tarQty"];
              delete obj["perAch"];
              return obj;
            });
          return csv;
        },
        order: () => {
          tileName &&
            {
              total: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Distributor PRIM Id"] = obj["distPrmId"] ?? "";
                    obj["Distributor Name"] = obj["distPrmName"] ?? "";
                    obj["Retailer PRM Id"] = obj["retailerPrmId"] ?? "";
                    obj["Retailer Name"] = obj["retailerPrmName"] ?? "";
                    obj["JC Id"] = obj["jcId"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["JP Id"] = obj["jpId"] ?? "";
                    obj["JP Name"] = obj["jpName"] ?? "";
                    obj["MNP"] = obj["mnp"] ?? "";
                    obj["Order Count"] = obj["orderCnt"] ?? "";
                    delete obj["distPrmId"];
                    delete obj["distPrmName"];
                    delete obj["retailerPrmId"];
                    delete obj["retailerPrmName"];
                    delete obj["jcId"];
                    delete obj["jcName"];
                    delete obj["jpId"];
                    delete obj["jpName"];
                    delete obj["mnp"];
                    delete obj["orderCnt"];
                    delete obj["posAgentCode"];
                    delete obj["posAgentName"];
                    delete obj["orn"];
                    delete obj["cafNo"];
                    delete obj["aoRej"];
                    delete obj["aoRejMsg"];
                    delete obj["tvPending"];
                    delete obj["tvRejected"];
                    return obj;
                  });
                return csv;
              },
              pending: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Distributor PRIM Id"] = obj["distPrmId"] ?? "";
                    obj["Distributor Name"] = obj["distPrmName"] ?? "";
                    obj["Retailer PRM Id"] = obj["retailerPrmId"] ?? "";
                    obj["Retailer Name"] = obj["retailerPrmName"] ?? "";
                    obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
                    obj["POS Agent Name"] = obj["posAgentName"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["JP Id"] = obj["jpId"] ?? "";
                    obj["JP Name"] = obj["jpName"] ?? "";
                    obj["ORN"] = obj["orn"] ?? "";
                    obj["CAF number"] = obj["cafNo"] ?? "";
                    obj["AO Rejected"] = obj["aoRej"] ?? "";
                    obj["AO Rejected Message"] = obj["aoRejMsg"] ?? "";
                    obj["TV Pending"] = obj["tvPending"] ?? "";
                    obj["TV Rejected"] = obj["tvRejected"] ?? "";
                    delete obj["distPrmId"];
                    delete obj["distPrmName"];
                    delete obj["retailerPrmId"];
                    delete obj["retailerPrmName"];
                    delete obj["jcId"];
                    delete obj["jcName"];
                    delete obj["jpId"];
                    delete obj["jpName"];
                    delete obj["mnp"];
                    delete obj["orderCnt"];
                    delete obj["posAgentCode"];
                    delete obj["posAgentName"];
                    delete obj["orn"];
                    delete obj["cafNo"];
                    delete obj["aoRej"];
                    delete obj["aoRejMsg"];
                    delete obj["tvPending"];
                    delete obj["tvRejected"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
          return csv;
        },
        JIOPHONE: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC"] = obj["jcCode"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["ARD"] = obj["rds"] ?? "";
              obj["ARD Name"] = obj["rdsName"] ?? "";
              obj["Retailer"] = obj["retailerId"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
              obj["Billing Type"] = obj["billingType"] ?? "";
              obj["MNP"] = obj["mnp"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgenRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgenRoleTypeName"] ?? "";
              obj["Offer Code"] = obj["offerCode"] ?? "";
              obj["Offer Category"] = obj["offerCategory"] ?? "";
              obj["E-KYC"] = obj["ekycFlag"] ?? "";
              obj["Plan"] = obj["plan"] ?? "";
              obj["Quantity"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zdCode"];
              delete obj["zdName"];
              delete obj["jcCode"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["billingType"];
              delete obj["mnp"];
              delete obj["posAgentCode"];
              delete obj["posAgenRoleTypeCode"];
              delete obj["posAgenRoleTypeName"];
              delete obj["offerCode"];
              delete obj["offerCategory"];
              delete obj["ekycFlag"];
              delete obj["plan"];
              delete obj["qty"];
              delete obj["perAch"];
              delete obj["retailerId"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeName"];
              delete obj["ard"];
              delete obj["ardName"];
              return obj;
            });
          return csv;
        },
      })[tile]();
      return csv;
    },
    ZDMT: () => {
      ({
        sim: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["ZD"] = obj["zd"] ?? "";
              obj["ZD Name"] = obj["zdName"] ?? "";
              obj["JC"] = obj["jcId"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["CHAIN"] = obj["rds"] ?? "";
              obj["CHAIN Name"] = obj["rdsName"] ?? "";
              obj["Store Id"] = obj["retailerId"] ?? "";
              obj["Store Name"] = obj["retailerName"] ?? "";
              obj["Billing Type"] = obj["billingTypeText"] ?? "";
              obj["MNP"] = obj["mnpFlag"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["Offer Code"] = obj["offerCode"] ?? "";
              obj["E-KYC"] = obj["ekycFlag"] ?? "";
              obj["Plan"] = obj["tarQty"] ?? "";
              obj["Quantity"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["billingTypeText"];
              delete obj["mnpFlag"];
              delete obj["posAgentCode"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["offerCode"];
              delete obj["offerCategory"];
              delete obj["ekycFlag"];
              delete obj["tarQty"];
              delete obj["qty"];
              delete obj["perAch"];
              delete obj["retailerId"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeName"];
              delete obj["ard"];
              delete obj["ardName"];
              return obj;
            });
          return csv;
        },
        daily: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["CHAIN Code"] = obj["retailerId"] ?? "";
              obj["CHAIN Name"] = obj["retailerName"] ?? "";
              obj["JC Code"] = obj["jcId"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Name"] = obj["posAgentName"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgentRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgentRoleTypeName"] ?? "";
              obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
              delete obj["retailerId"];
              delete obj["retailerName"];
              delete obj["posAgentCode"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["posAgentRoleTypeName"];
              delete obj["jprTypeName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["tarQty"];
              delete obj["rdsName"];
              delete obj["rdsId"];
              return obj;
            });
          return csv;
        },
        last: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["ZDMT Code"] = obj["zd"] ?? "";
              obj["ZDMT Name"] = obj["zdName"] ?? "";
              obj["CHAIN Code"] = obj["rds"] ?? "";
              obj["CHAIN Name"] = obj["rdsName"] ?? "";
              obj["Store Code"] = obj["retailerId"] ?? "";
              obj["Store Name"] = obj["retailerName"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Name"] = obj["posAgentName"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgentRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgentRoleTypeName"] ?? "";
              obj["Offer Category"] = obj["offerCategory"] ?? "";
              obj["Qty"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailerId"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["posAgentCode"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["posAgentRoleTypeName"];
              delete obj["offerCategory"];
              delete obj["qty"];
              delete obj["ard"];
              delete obj["ardName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["billingTypeText"];
              delete obj["offerCode"];
              delete obj["ekycFlag"];
              delete obj["mnpFlag"];
              delete obj["tarQty"];
              delete obj["perAch"];
              return obj;
            });
          return csv;
        },
        JIOPHONE: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["ZDMT"] = obj["zdCode"] ?? "";
              obj["ZDMT Name"] = obj["zdName"] ?? "";
              obj["JC"] = obj["jcCode"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["CHAIN"] = obj["rds"] ?? "";
              obj["CHAIN Name"] = obj["rdsName"] ?? "";
              obj["Store"] = obj["retailerId"] ?? "";
              obj["Store Name"] = obj["retailerName"] ?? "";
              obj["Billing Type"] = obj["billingType"] ?? "";
              obj["MNP"] = obj["mnp"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgenRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgenRoleTypeName"] ?? "";
              obj["Offer Code"] = obj["offerCode"] ?? "";
              obj["Offer Category"] = obj["offerCategory"] ?? "";
              obj["E-KYC"] = obj["ekycFlag"] ?? "";
              obj["Plan"] = obj["plan"] ?? "";
              obj["Quantity"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zdCode"];
              delete obj["zdName"];
              delete obj["jcCode"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["billingType"];
              delete obj["mnp"];
              delete obj["posAgentCode"];
              delete obj["posAgenRoleTypeCode"];
              delete obj["posAgenRoleTypeName"];
              delete obj["offerCode"];
              delete obj["offerCategory"];
              delete obj["ekycFlag"];
              delete obj["plan"];
              delete obj["qty"];
              delete obj["perAch"];
              delete obj["retailerId"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeName"];
              delete obj["ard"];
              delete obj["ardName"];
              return obj;
            });
          return csv;
        },
      })[tile]();
      return csv;
    },
    RDS: () => {
      ({
        sim: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC"] = obj["jcId"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["RDS"] = obj["rds"] ?? "";
              obj["RDS Name"] = obj["rdsName"] ?? "";
              obj["Retailer"] = obj["retailerId"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["Billing Type"] = obj["billingTypeText"] ?? "";
              obj["MNP"] = obj["mnpFlag"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["Offer Code"] = obj["offerCode"] ?? "";
              obj["E-KYC"] = obj["ekycFlag"] ?? "";
              obj["Plan"] = obj["tarQty"] ?? "";
              obj["Quantity"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["billingTypeText"];
              delete obj["mnpFlag"];
              delete obj["posAgentCode"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["offerCode"];
              delete obj["offerCategory"];
              delete obj["ekycFlag"];
              delete obj["tarQty"];
              delete obj["qty"];
              delete obj["perAch"];
              delete obj["retailerId"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeName"];
              delete obj["ard"];
              delete obj["ardName"];
              return obj;
            });
          return csv;
        },
        daily: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Retailer Code"] = obj["retailerId"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["JC Code"] = obj["jcId"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Name"] = obj["posAgentName"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgentRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgentRoleTypeName"] ?? "";
              obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
              delete obj["retailerId"];
              delete obj["retailerName"];
              delete obj["posAgentCode"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["posAgentRoleTypeName"];
              delete obj["jprTypeName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["tarQty"];
              delete obj["rdsName"];
              delete obj["rdsId"];
              return obj;
            });
          return csv;
        },
        last: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["RDS Code"] = obj["rds"] ?? "";
              obj["RDS Name"] = obj["rdsName"] ?? "";
              obj["Retailer Code"] = obj["retailerId"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Name"] = obj["posAgentName"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgentRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgentRoleTypeName"] ?? "";
              obj["Offer Category"] = obj["offerCategory"] ?? "";
              obj["Qty"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailerId"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["posAgentCode"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["posAgentRoleTypeName"];
              delete obj["offerCategory"];
              delete obj["qty"];
              delete obj["ard"];
              delete obj["ardName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["billingTypeText"];
              delete obj["offerCode"];
              delete obj["ekycFlag"];
              delete obj["mnpFlag"];
              delete obj["tarQty"];
              delete obj["perAch"];
              return obj;
            });
          return csv;
        },
        order: () => {
          tileName &&
            {
              total: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Distributor PRIM Id"] = obj["distPrmId"] ?? "";
                    obj["Distributor Name"] = obj["distPrmName"] ?? "";
                    obj["Retailer PRM Id"] = obj["retailerPrmId"] ?? "";
                    obj["Retailer Name"] = obj["retailerPrmName"] ?? "";
                    obj["JC Id"] = obj["jcId"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["JP Id"] = obj["jpId"] ?? "";
                    obj["JP Name"] = obj["jpName"] ?? "";
                    obj["MNP"] = obj["mnp"] ?? "";
                    obj["Order Count"] = obj["orderCnt"] ?? "";
                    delete obj["distPrmId"];
                    delete obj["distPrmName"];
                    delete obj["retailerPrmId"];
                    delete obj["retailerPrmName"];
                    delete obj["jcId"];
                    delete obj["jcName"];
                    delete obj["jpId"];
                    delete obj["jpName"];
                    delete obj["mnp"];
                    delete obj["orderCnt"];
                    delete obj["posAgentCode"];
                    delete obj["posAgentName"];
                    delete obj["orn"];
                    delete obj["cafNo"];
                    delete obj["aoRej"];
                    delete obj["aoRejMsg"];
                    delete obj["tvPending"];
                    delete obj["tvRejected"];
                    return obj;
                  });
                return csv;
              },
              pending: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Distributor PRIM Id"] = obj["distPrmId"] ?? "";
                    obj["Distributor Name"] = obj["distPrmName"] ?? "";
                    obj["Retailer PRM Id"] = obj["retailerPrmId"] ?? "";
                    obj["Retailer Name"] = obj["retailerPrmName"] ?? "";
                    obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
                    obj["POS Agent Name"] = obj["posAgentName"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["JP Id"] = obj["jpId"] ?? "";
                    obj["JP Name"] = obj["jpName"] ?? "";
                    obj["ORN"] = obj["orn"] ?? "";
                    obj["CAF number"] = obj["cafNo"] ?? "";
                    obj["AO Rejected"] = obj["aoRej"] ?? "";
                    obj["AO Rejected Message"] = obj["aoRejMsg"] ?? "";
                    obj["TV Pending"] = obj["tvPending"] ?? "";
                    obj["TV Rejected"] = obj["tvRejected"] ?? "";
                    delete obj["distPrmId"];
                    delete obj["distPrmName"];
                    delete obj["retailerPrmId"];
                    delete obj["retailerPrmName"];
                    delete obj["jcId"];
                    delete obj["jcName"];
                    delete obj["jpId"];
                    delete obj["jpName"];
                    delete obj["mnp"];
                    delete obj["orderCnt"];
                    delete obj["posAgentCode"];
                    delete obj["posAgentName"];
                    delete obj["orn"];
                    delete obj["cafNo"];
                    delete obj["aoRej"];
                    delete obj["aoRejMsg"];
                    delete obj["tvPending"];
                    delete obj["tvRejected"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
          return csv;
        },
        JIOPHONE: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["ZD"] = obj["zdCode"] ?? "";
              obj["ZD Name"] = obj["zdName"] ?? "";
              obj["JC"] = obj["jcCode"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["RDS"] = obj["rds"] ?? "";
              obj["RDS Name"] = obj["rdsName"] ?? "";
              obj["Retailer"] = obj["retailerId"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
              obj["Billing Type"] = obj["billingType"] ?? "";
              obj["MNP"] = obj["mnp"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgenRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgenRoleTypeName"] ?? "";
              obj["Offer Code"] = obj["offerCode"] ?? "";
              obj["Offer Category"] = obj["offerCategory"] ?? "";
              obj["E-KYC"] = obj["ekycFlag"] ?? "";
              obj["Plan"] = obj["plan"] ?? "";
              obj["Quantity"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zdCode"];
              delete obj["zdName"];
              delete obj["jcCode"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["billingType"];
              delete obj["mnp"];
              delete obj["posAgentCode"];
              delete obj["posAgenRoleTypeCode"];
              delete obj["posAgenRoleTypeName"];
              delete obj["offerCode"];
              delete obj["offerCategory"];
              delete obj["ekycFlag"];
              delete obj["plan"];
              delete obj["qty"];
              delete obj["perAch"];
              delete obj["retailerId"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeName"];
              delete obj["ard"];
              delete obj["ardName"];
              return obj;
            });
          return csv;
        },
      })[tile]();
      return csv;
    },
    MARD: () => {
      ({
        sim: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC"] = obj["jcId"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["MARD"] = obj["rds"] ?? "";
              obj["MARD Name"] = obj["rdsName"] ?? "";
              obj["UAO/URO Code"] = obj["retailerId"] ?? "";
              obj["UAO/URO Name"] = obj["retailerName"] ?? "";
              obj["Billing Type"] = obj["billingTypeText"] ?? "";
              obj["MNP"] = obj["mnpFlag"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["Offer Code"] = obj["offerCode"] ?? "";
              obj["E-KYC"] = obj["ekycFlag"] ?? "";
              obj["Plan"] = obj["tarQty"] ?? "";
              obj["Quantity"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["billingTypeText"];
              delete obj["mnpFlag"];
              delete obj["posAgentCode"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["offerCode"];
              delete obj["offerCategory"];
              delete obj["ekycFlag"];
              delete obj["tarQty"];
              delete obj["qty"];
              delete obj["perAch"];
              delete obj["retailerId"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeName"];
              delete obj["ard"];
              delete obj["ardName"];
              return obj;
            });
          return csv;
        },
        daily: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["UAO/URO Code"] = obj["retailerId"] ?? "";
              obj["UAO/URO Name"] = obj["retailerName"] ?? "";
              obj["JC Code"] = obj["jcId"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Name"] = obj["posAgentName"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgentRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgentRoleTypeName"] ?? "";
              obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
              delete obj["retailerId"];
              delete obj["retailerName"];
              delete obj["posAgentCode"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["posAgentRoleTypeName"];
              delete obj["jprTypeName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["tarQty"];
              delete obj["rdsName"];
              delete obj["rdsId"];
              return obj;
            });
          return csv;
        },
        last: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["MARD Code"] = obj["ard"] ?? "";
              obj["MARD Name"] = obj["ardName"] ?? "";
              obj["UAO Code"] = obj["retailerId"] ?? "";
              obj["URO Name"] = obj["retailerName"] ?? "";
              obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Name"] = obj["posAgentName"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgentRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgentRoleTypeName"] ?? "";
              obj["Offer Category"] = obj["offerCategory"] ?? "";
              obj["Qty"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailerId"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["posAgentCode"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["posAgentRoleTypeName"];
              delete obj["offerCategory"];
              delete obj["qty"];
              delete obj["ard"];
              delete obj["ardName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["billingTypeText"];
              delete obj["offerCode"];
              delete obj["ekycFlag"];
              delete obj["mnpFlag"];
              delete obj["tarQty"];
              delete obj["perAch"];
              return obj;
            });
          return csv;
        },
        order: () => {
          tileName &&
            {
              total: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Distributor PRIM Id"] = obj["distPrmId"] ?? "";
                    obj["Distributor Name"] = obj["distPrmName"] ?? "";
                    obj["Retailer PRM Id"] = obj["retailerPrmId"] ?? "";
                    obj["Retailer Name"] = obj["retailerPrmName"] ?? "";
                    obj["JC Id"] = obj["jcId"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["JP Id"] = obj["jpId"] ?? "";
                    obj["JP Name"] = obj["jpName"] ?? "";
                    obj["MNP"] = obj["mnp"] ?? "";
                    obj["Order Count"] = obj["orderCnt"] ?? "";
                    delete obj["distPrmId"];
                    delete obj["distPrmName"];
                    delete obj["retailerPrmId"];
                    delete obj["retailerPrmName"];
                    delete obj["jcId"];
                    delete obj["jcName"];
                    delete obj["jpId"];
                    delete obj["jpName"];
                    delete obj["mnp"];
                    delete obj["orderCnt"];
                    delete obj["posAgentCode"];
                    delete obj["posAgentName"];
                    delete obj["orn"];
                    delete obj["cafNo"];
                    delete obj["aoRej"];
                    delete obj["aoRejMsg"];
                    delete obj["tvPending"];
                    delete obj["tvRejected"];
                    return obj;
                  });
                return csv;
              },
              pending: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Distributor PRIM Id"] = obj["distPrmId"] ?? "";
                    obj["Distributor Name"] = obj["distPrmName"] ?? "";
                    obj["Retailer PRM Id"] = obj["retailerPrmId"] ?? "";
                    obj["Retailer Name"] = obj["retailerPrmName"] ?? "";
                    obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
                    obj["POS Agent Name"] = obj["posAgentName"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["JP Id"] = obj["jpId"] ?? "";
                    obj["JP Name"] = obj["jpName"] ?? "";
                    obj["ORN"] = obj["orn"] ?? "";
                    obj["CAF number"] = obj["cafNo"] ?? "";
                    obj["AO Rejected"] = obj["aoRej"] ?? "";
                    obj["AO Rejected Message"] = obj["aoRejMsg"] ?? "";
                    obj["TV Pending"] = obj["tvPending"] ?? "";
                    obj["TV Rejected"] = obj["tvRejected"] ?? "";
                    delete obj["distPrmId"];
                    delete obj["distPrmName"];
                    delete obj["retailerPrmId"];
                    delete obj["retailerPrmName"];
                    delete obj["jcId"];
                    delete obj["jcName"];
                    delete obj["jpId"];
                    delete obj["jpName"];
                    delete obj["mnp"];
                    delete obj["orderCnt"];
                    delete obj["posAgentCode"];
                    delete obj["posAgentName"];
                    delete obj["orn"];
                    delete obj["cafNo"];
                    delete obj["aoRej"];
                    delete obj["aoRejMsg"];
                    delete obj["tvPending"];
                    delete obj["tvRejected"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
          return csv;
        },
        JIOPHONE: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC"] = obj["jcCode"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["MARD"] = obj["rds"] ?? "";
              obj["MARD Name"] = obj["rdsName"] ?? "";
              obj["Retailer"] = obj["retailerId"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
              obj["Billing Type"] = obj["billingType"] ?? "";
              obj["MNP"] = obj["mnp"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgenRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgenRoleTypeName"] ?? "";
              obj["Offer Code"] = obj["offerCode"] ?? "";
              obj["Offer Category"] = obj["offerCategory"] ?? "";
              obj["E-KYC"] = obj["ekycFlag"] ?? "";
              obj["Plan"] = obj["plan"] ?? "";
              obj["Quantity"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zdCode"];
              delete obj["zdName"];
              delete obj["jcCode"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["billingType"];
              delete obj["mnp"];
              delete obj["posAgentCode"];
              delete obj["posAgenRoleTypeCode"];
              delete obj["posAgenRoleTypeName"];
              delete obj["offerCode"];
              delete obj["offerCategory"];
              delete obj["ekycFlag"];
              delete obj["plan"];
              delete obj["qty"];
              delete obj["perAch"];
              delete obj["retailerId"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeName"];
              delete obj["ard"];
              delete obj["ardName"];
              return obj;
            });
          return csv;
        },
      })[tile]();
      return csv;
    },
    END: () => {
      ({
        sim: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["Retailer"] = obj["retailerId"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["Billing Type"] = obj["billingTypeText"] ?? "";
              obj["MNP"] = obj["mnpFlag"] ?? "";
              obj["Plan"] = obj["tarQty"] ?? "";
              obj["Quantity"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["billingTypeText"];
              delete obj["mnpFlag"];
              delete obj["posAgentCode"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["offerCode"];
              delete obj["offerCategory"];
              delete obj["ekycFlag"];
              delete obj["tarQty"];
              delete obj["qty"];
              delete obj["perAch"];
              delete obj["retailerId"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeName"];
              delete obj["ard"];
              delete obj["ardName"];
              return obj;
            });
        },
        daily: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Retailer Code"] = obj["retailerId"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["JC Code"] = obj["jcId"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Name"] = obj["posAgentName"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgentRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgentRoleTypeName"] ?? "";
              obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
              delete obj["retailerId"];
              delete obj["retailerName"];
              delete obj["posAgentCode"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["posAgentRoleTypeName"];
              delete obj["jprTypeName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["tarQty"];
              delete obj["rdsName"];
              delete obj["rdsId"];
              return obj;
            });
          return csv;
        },
        last: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["ED ZD Code"] = obj["zd"] ?? "";
              obj["ED ZD Name"] = obj["zdName"] ?? "";
              obj["Retailer Code"] = obj["retailerId"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Name"] = obj["posAgentName"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgentRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgentRoleTypeName"] ?? "";
              obj["Offer Category"] = obj["offerCategory"] ?? "";
              obj["Qty"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailerId"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["posAgentCode"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["posAgentRoleTypeName"];
              delete obj["offerCategory"];
              delete obj["qty"];
              delete obj["ard"];
              delete obj["ardName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["billingTypeText"];
              delete obj["offerCode"];
              delete obj["ekycFlag"];
              delete obj["mnpFlag"];
              delete obj["tarQty"];
              delete obj["perAch"];
              return obj;
            });
          return csv;
        },
        order: () => {
          tileName &&
            {
              total: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Distributor PRIM Id"] = obj["distPrmId"] ?? "";
                    obj["Distributor Name"] = obj["distPrmName"] ?? "";
                    obj["Retailer PRM Id"] = obj["retailerPrmId"] ?? "";
                    obj["Retailer Name"] = obj["retailerPrmName"] ?? "";
                    obj["JC Id"] = obj["jcId"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["JP Id"] = obj["jpId"] ?? "";
                    obj["JP Name"] = obj["jpName"] ?? "";
                    obj["MNP"] = obj["mnp"] ?? "";
                    obj["Order Count"] = obj["orderCnt"] ?? "";
                    delete obj["distPrmId"];
                    delete obj["distPrmName"];
                    delete obj["retailerPrmId"];
                    delete obj["retailerPrmName"];
                    delete obj["jcId"];
                    delete obj["jcName"];
                    delete obj["jpId"];
                    delete obj["jpName"];
                    delete obj["mnp"];
                    delete obj["orderCnt"];
                    delete obj["posAgentCode"];
                    delete obj["posAgentName"];
                    delete obj["orn"];
                    delete obj["cafNo"];
                    delete obj["aoRej"];
                    delete obj["aoRejMsg"];
                    delete obj["tvPending"];
                    delete obj["tvRejected"];
                    return obj;
                  });
                return csv;
              },
              pending: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Distributor PRIM Id"] = obj["distPrmId"] ?? "";
                    obj["Distributor Name"] = obj["distPrmName"] ?? "";
                    obj["Retailer PRM Id"] = obj["retailerPrmId"] ?? "";
                    obj["Retailer Name"] = obj["retailerPrmName"] ?? "";
                    obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
                    obj["POS Agent Name"] = obj["posAgentName"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["JP Id"] = obj["jpId"] ?? "";
                    obj["JP Name"] = obj["jpName"] ?? "";
                    obj["ORN"] = obj["orn"] ?? "";
                    obj["CAF number"] = obj["cafNo"] ?? "";
                    obj["AO Rejected"] = obj["aoRej"] ?? "";
                    obj["AO Rejected Message"] = obj["aoRejMsg"] ?? "";
                    obj["TV Pending"] = obj["tvPending"] ?? "";
                    obj["TV Rejected"] = obj["tvRejected"] ?? "";
                    delete obj["distPrmId"];
                    delete obj["distPrmName"];
                    delete obj["retailerPrmId"];
                    delete obj["retailerPrmName"];
                    delete obj["jcId"];
                    delete obj["jcName"];
                    delete obj["jpId"];
                    delete obj["jpName"];
                    delete obj["mnp"];
                    delete obj["orderCnt"];
                    delete obj["posAgentCode"];
                    delete obj["posAgentName"];
                    delete obj["orn"];
                    delete obj["cafNo"];
                    delete obj["aoRej"];
                    delete obj["aoRejMsg"];
                    delete obj["tvPending"];
                    delete obj["tvRejected"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
          return csv;
        },
        JIOPHONE: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["ED ZD"] = obj["zdCode"] ?? "";
              obj["ED ZD Name"] = obj["zdName"] ?? "";
              obj["Billing Type"] = obj["billingType"] ?? "";
              obj["MNP"] = obj["mnp"] ?? "";
              obj["E-KYC"] = obj["ekycFlag"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zdCode"];
              delete obj["zdName"];
              delete obj["jcCode"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["billingType"];
              delete obj["mnp"];
              delete obj["posAgentCode"];
              delete obj["posAgenRoleTypeCode"];
              delete obj["posAgenRoleTypeName"];
              delete obj["offerCode"];
              delete obj["offerCategory"];
              delete obj["ekycFlag"];
              delete obj["plan"];
              delete obj["qty"];
              delete obj["perAch"];
              delete obj["retailerId"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeName"];
              delete obj["ard"];
              delete obj["ardName"];
              return obj;
            });
          return csv;
        },
      })[tile]();
      return csv;
    },
    RZD: () => {
      ({
        sim: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC"] = obj["jcId"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["RZD"] = obj["ard"] ?? "";
              obj["RZD Name"] = obj["ardName"] ?? "";
              obj["DRS Code"] = obj["retailerId"] ?? "";
              obj["DRS Name"] = obj["retailerName"] ?? "";
              obj["Billing Type"] = obj["billingTypeText"] ?? "";
              obj["MNP"] = obj["mnpFlag"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["Offer Code"] = obj["offerCode"] ?? "";
              obj["E-KYC"] = obj["ekycFlag"] ?? "";
              obj["Plan"] = obj["tarQty"] ?? "";
              obj["Quantity"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["billingTypeText"];
              delete obj["mnpFlag"];
              delete obj["posAgentCode"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["offerCode"];
              delete obj["offerCategory"];
              delete obj["ekycFlag"];
              delete obj["tarQty"];
              delete obj["qty"];
              delete obj["perAch"];
              delete obj["retailerId"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeName"];
              delete obj["ard"];
              delete obj["ardName"];
              return obj;
            });
          return csv;
        },
        daily: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["DRS Code"] = obj["retailerId"] ?? "";
              obj["DRS Name"] = obj["retailerName"] ?? "";
              obj["JC Code"] = obj["jcId"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Name"] = obj["posAgentName"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgentRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgentRoleTypeName"] ?? "";
              obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
              delete obj["retailerId"];
              delete obj["retailerName"];
              delete obj["posAgentCode"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["posAgentRoleTypeName"];
              delete obj["jprTypeName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["tarQty"];
              delete obj["rdsName"];
              delete obj["rdsId"];
              return obj;
            });
          return csv;
        },
        last: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["RZD Code"] = obj["ard"] ?? "";
              obj["RZD Name"] = obj["ardName"] ?? "";
              obj["DRS Code"] = obj["retailerId"] ?? "";
              obj["DRS Name"] = obj["retailerName"] ?? "";
              obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Name"] = obj["posAgentName"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgentRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgentRoleTypeName"] ?? "";
              obj["Offer Category"] = obj["offerCategory"] ?? "";
              obj["Qty"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailerId"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["posAgentCode"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["posAgentRoleTypeName"];
              delete obj["offerCategory"];
              delete obj["qty"];
              delete obj["ard"];
              delete obj["ardName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["billingTypeText"];
              delete obj["offerCode"];
              delete obj["ekycFlag"];
              delete obj["mnpFlag"];
              delete obj["tarQty"];
              delete obj["perAch"];
              return obj;
            });
          return csv;
        },
        JIOPHONE: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["RZD"] = obj["zdCode"] ?? "";
              obj["RZD Name"] = obj["zdName"] ?? "";
              obj["JC"] = obj["jcCode"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["Retailer"] = obj["rds"] ?? "";
              obj["Retailer Name"] = obj["rdsName"] ?? "";
              obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
              obj["Billing Type"] = obj["billingType"] ?? "";
              obj["MNP"] = obj["mnp"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgenRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgenRoleTypeName"] ?? "";
              obj["Offer Code"] = obj["offerCode"] ?? "";
              obj["Offer Category"] = obj["offerCategory"] ?? "";
              obj["E-KYC"] = obj["ekycFlag"] ?? "";
              obj["Plan"] = obj["plan"] ?? "";
              obj["Quantity"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zdCode"];
              delete obj["zdName"];
              delete obj["jcCode"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["billingType"];
              delete obj["mnp"];
              delete obj["posAgentCode"];
              delete obj["posAgenRoleTypeCode"];
              delete obj["posAgenRoleTypeName"];
              delete obj["offerCode"];
              delete obj["offerCategory"];
              delete obj["ekycFlag"];
              delete obj["plan"];
              delete obj["qty"];
              delete obj["perAch"];
              delete obj["retailerId"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeName"];
              delete obj["ard"];
              delete obj["ardName"];
              return obj;
            });
          return csv;
        },
      })[tile]();
      return csv;
    },
    ITZ: () => {
      ({
        sim: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["IT ZD"] = obj["zd"] ?? "";
              obj["IT ZD Name"] = obj["zdName"] ?? "";
              obj["ITD"] = obj["rds"] ?? "";
              obj["ITD Name"] = obj["rdsName"] ?? "";
              obj["Retailer"] = obj["retailerId"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["Billing Type"] = obj["billingTypeText"] ?? "";
              obj["MNP"] = obj["mnpFlag"] ?? "";
              obj["Plan"] = obj["tarQty"] ?? "";
              obj["Quantity"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["billingTypeText"];
              delete obj["mnpFlag"];
              delete obj["posAgentCode"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["offerCode"];
              delete obj["offerCategory"];
              delete obj["ekycFlag"];
              delete obj["tarQty"];
              delete obj["qty"];
              delete obj["perAch"];
              delete obj["retailerId"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeName"];
              delete obj["ard"];
              delete obj["ardName"];
              return obj;
            });
          return csv;
        },
        daily: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Retailer Code"] = obj["retailerId"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["JC Code"] = obj["jcId"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Name"] = obj["posAgentName"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgentRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgentRoleTypeName"] ?? "";
              delete obj["retailerId"];
              delete obj["retailerName"];
              delete obj["posAgentCode"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["posAgentRoleTypeName"];
              delete obj["jprTypeName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["tarQty"];
              delete obj["rdsName"];
              delete obj["rdsId"];
              return obj;
            });
          return csv;
        },
        last: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["IT ZD Code"] = obj["zd"] ?? "";
              obj["IT ZD Name"] = obj["zdName"] ?? "";
              obj["ITD Code"] = obj["rds"] ?? "";
              obj["ITD Name"] = obj["rdsName"] ?? "";
              obj["Retailer Code"] = obj["retailerId"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Name"] = obj["posAgentName"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgentRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgentRoleTypeName"] ?? "";
              obj["Offer Category"] = obj["offerCategory"] ?? "";
              obj["Qty"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailerId"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["posAgentCode"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["posAgentRoleTypeName"];
              delete obj["offerCategory"];
              delete obj["qty"];
              delete obj["ard"];
              delete obj["ardName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["billingTypeText"];
              delete obj["offerCode"];
              delete obj["ekycFlag"];
              delete obj["mnpFlag"];
              delete obj["tarQty"];
              delete obj["perAch"];
              return obj;
            });
          return csv;
        },
        JIOPHONE: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["IT ZD"] = obj["zdCode"] ?? "";
              obj["IT ZD Name"] = obj["zdName"] ?? "";
              obj["JC"] = obj["jcCode"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["IT RDS"] = obj["rds"] ?? "";
              obj["IT RDS Name"] = obj["rdsName"] ?? "";
              obj["Retailer"] = obj["retailerId"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
              obj["Billing Type"] = obj["billingType"] ?? "";
              obj["MNP"] = obj["mnp"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgenRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgenRoleTypeName"] ?? "";
              obj["Offer Code"] = obj["offerCode"] ?? "";
              obj["Offer Category"] = obj["offerCategory"] ?? "";
              obj["E-KYC"] = obj["ekycFlag"] ?? "";
              obj["Plan"] = obj["plan"] ?? "";
              obj["Quantity"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zdCode"];
              delete obj["zdName"];
              delete obj["jcCode"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["billingType"];
              delete obj["mnp"];
              delete obj["posAgentCode"];
              delete obj["posAgenRoleTypeCode"];
              delete obj["posAgenRoleTypeName"];
              delete obj["offerCode"];
              delete obj["offerCategory"];
              delete obj["ekycFlag"];
              delete obj["plan"];
              delete obj["qty"];
              delete obj["perAch"];
              delete obj["retailerId"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeName"];
              delete obj["ard"];
              delete obj["ardName"];
              return obj;
            });
          return csv;
        },
      })[tile]();
      return csv;
    },
    ITD: () => {
      ({
        sim: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["IT ZD"] = obj["zd"] ?? "";
              obj["IT ZD Name"] = obj["zdName"] ?? "";
              obj["ITD"] = obj["rds"] ?? "";
              obj["ITD Name"] = obj["rdsName"] ?? "";
              obj["Retailer"] = obj["retailerId"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["Billing Type"] = obj["billingTypeText"] ?? "";
              obj["MNP"] = obj["mnpFlag"] ?? "";
              obj["Plan"] = obj["tarQty"] ?? "";
              obj["Quantity"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["billingTypeText"];
              delete obj["mnpFlag"];
              delete obj["posAgentCode"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["offerCode"];
              delete obj["offerCategory"];
              delete obj["ekycFlag"];
              delete obj["tarQty"];
              delete obj["qty"];
              delete obj["perAch"];
              delete obj["retailerId"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeName"];
              delete obj["ard"];
              delete obj["ardName"];
              return obj;
            });
          return csv;
        },
        daily: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Retailer Code"] = obj["retailerId"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["JC Code"] = obj["jcId"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Name"] = obj["posAgentName"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgentRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgentRoleTypeName"] ?? "";
              delete obj["retailerId"];
              delete obj["retailerName"];
              delete obj["posAgentCode"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["posAgentRoleTypeName"];
              delete obj["jprTypeName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["tarQty"];
              delete obj["rdsName"];
              delete obj["rdsId"];
              return obj;
            });
          return csv;
        },
        last: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["IT ZD Code"] = obj["zd"] ?? "";
              obj["IT ZD Name"] = obj["zdName"] ?? "";
              obj["ITD Code"] = obj["rds"] ?? "";
              obj["ITD Name"] = obj["rdsName"] ?? "";
              obj["Retailer Code"] = obj["retailerId"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Name"] = obj["posAgentName"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgentRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgentRoleTypeName"] ?? "";
              obj["Offer Category"] = obj["offerCategory"] ?? "";
              obj["Qty"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zd"];
              delete obj["zdName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailerId"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["posAgentCode"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeCode"];
              delete obj["posAgentRoleTypeName"];
              delete obj["offerCategory"];
              delete obj["qty"];
              delete obj["ard"];
              delete obj["ardName"];
              delete obj["jcId"];
              delete obj["jcName"];
              delete obj["billingTypeText"];
              delete obj["offerCode"];
              delete obj["ekycFlag"];
              delete obj["mnpFlag"];
              delete obj["tarQty"];
              delete obj["perAch"];
              return obj;
            });
          return csv;
        },
        order: () => {
          tileName &&
            {
              total: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Distributor PRIM Id"] = obj["distPrmId"] ?? "";
                    obj["Distributor Name"] = obj["distPrmName"] ?? "";
                    obj["Retailer PRM Id"] = obj["retailerPrmId"] ?? "";
                    obj["Retailer Name"] = obj["retailerPrmName"] ?? "";
                    obj["JC Id"] = obj["jcId"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["JP Id"] = obj["jpId"] ?? "";
                    obj["JP Name"] = obj["jpName"] ?? "";
                    obj["MNP"] = obj["mnp"] ?? "";
                    obj["Order Count"] = obj["orderCnt"] ?? "";
                    delete obj["distPrmId"];
                    delete obj["distPrmName"];
                    delete obj["retailerPrmId"];
                    delete obj["retailerPrmName"];
                    delete obj["jcId"];
                    delete obj["jcName"];
                    delete obj["jpId"];
                    delete obj["jpName"];
                    delete obj["mnp"];
                    delete obj["orderCnt"];
                    delete obj["posAgentCode"];
                    delete obj["posAgentName"];
                    delete obj["orn"];
                    delete obj["cafNo"];
                    delete obj["aoRej"];
                    delete obj["aoRejMsg"];
                    delete obj["tvPending"];
                    delete obj["tvRejected"];
                    return obj;
                  });
                return csv;
              },
              pending: () => {
                csv =
                  content &&
                  content.map((obj) => {
                    obj["Distributor PRIM Id"] = obj["distPrmId"] ?? "";
                    obj["Distributor Name"] = obj["distPrmName"] ?? "";
                    obj["Retailer PRM Id"] = obj["retailerPrmId"] ?? "";
                    obj["Retailer Name"] = obj["retailerPrmName"] ?? "";
                    obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
                    obj["POS Agent Name"] = obj["posAgentName"] ?? "";
                    obj["JC Name"] = obj["jcName"] ?? "";
                    obj["JP Id"] = obj["jpId"] ?? "";
                    obj["JP Name"] = obj["jpName"] ?? "";
                    obj["ORN"] = obj["orn"] ?? "";
                    obj["CAF number"] = obj["cafNo"] ?? "";
                    obj["AO Rejected"] = obj["aoRej"] ?? "";
                    obj["AO Rejected Message"] = obj["aoRejMsg"] ?? "";
                    obj["TV Pending"] = obj["tvPending"] ?? "";
                    obj["TV Rejected"] = obj["tvRejected"] ?? "";
                    delete obj["distPrmId"];
                    delete obj["distPrmName"];
                    delete obj["retailerPrmId"];
                    delete obj["retailerPrmName"];
                    delete obj["jcId"];
                    delete obj["jcName"];
                    delete obj["jpId"];
                    delete obj["jpName"];
                    delete obj["mnp"];
                    delete obj["orderCnt"];
                    delete obj["posAgentCode"];
                    delete obj["posAgentName"];
                    delete obj["orn"];
                    delete obj["cafNo"];
                    delete obj["aoRej"];
                    delete obj["aoRejMsg"];
                    delete obj["tvPending"];
                    delete obj["tvRejected"];
                    return obj;
                  });
                return csv;
              },
            }[tileName]();
          return csv;
        },
        JIOPHONE: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["IT ZD"] = obj["zdCode"] ?? "";
              obj["IT ZD Name"] = obj["zdName"] ?? "";
              obj["JC"] = obj["jcCode"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["IT RDS"] = obj["rds"] ?? "";
              obj["IT RDS Name"] = obj["rdsName"] ?? "";
              obj["Retailer"] = obj["retailerId"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
              obj["Billing Type"] = obj["billingType"] ?? "";
              obj["MNP"] = obj["mnp"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgenRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgenRoleTypeName"] ?? "";
              obj["Offer Code"] = obj["offerCode"] ?? "";
              obj["Offer Category"] = obj["offerCategory"] ?? "";
              obj["E-KYC"] = obj["ekycFlag"] ?? "";
              obj["Plan"] = obj["plan"] ?? "";
              obj["Quantity"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zdCode"];
              delete obj["zdName"];
              delete obj["jcCode"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["billingType"];
              delete obj["mnp"];
              delete obj["posAgentCode"];
              delete obj["posAgenRoleTypeCode"];
              delete obj["posAgenRoleTypeName"];
              delete obj["offerCode"];
              delete obj["offerCategory"];
              delete obj["ekycFlag"];
              delete obj["plan"];
              delete obj["qty"];
              delete obj["perAch"];
              delete obj["retailerId"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeName"];
              delete obj["ard"];
              delete obj["ardName"];
              return obj;
            });
          return csv;
        },
      })[tile]();
      return csv;
    },
    JPT: () => {
      ({
        sim: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC ID"] = obj["jc_id"] ?? "";
              obj["JC Name"] = obj["jc_name"] ?? "";
              obj["JIO Point Id"] = obj["jio_point_id"] ?? "";
              obj["JIO Point Name"] = obj["jio_point_name"] ?? "";
              obj["Retailer Id"] = obj["retailer_id"] ?? "";
              obj["Retailer Name"] = obj["retailer_name"] ?? "";
              obj["POS Agent Id"] = obj["pos_agent_Code"] ?? "";
              obj["BILLING TYPE"] = obj["billing_type_text"] ?? "";
              obj["MNP"] = obj["mnp_flag"] ?? "";
              obj["OFFER ID"] = obj["offer_code"] ?? "";
              obj["TAR QUANTITY"] = obj["tar_qt"] ?? "";
              obj["QUANTITY"] = obj["qty"] ?? "";
              obj["EKYC FLAG"] = obj["ekyc_flag"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jc_id"];
              delete obj["jc_name"];
              delete obj["jio_point_id"];
              delete obj["jio_point_name"];
              delete obj["retailer_id"];
              delete obj["retailer_name"];
              delete obj["pos_agent_Code"];
              delete obj["pos_agent_Name"];
              delete obj["pos_agent_role_type_code"];
              delete obj["pos_agent_role_type_name"];
              delete obj["jpr_type_code"];
              delete obj["jpr_type_name"];
              delete obj["billing_type_text"];
              delete obj["mnp_flag"];
              delete obj["offer_code"];
              delete obj["offer_category"];
              delete obj["tar_qt"];
              delete obj["qty"];
              delete obj["ekyc_flag"];
              return obj;
            });
        },
        daily: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["JC ID"] = obj["jc_id"] ?? "";
              obj["JC Name"] = obj["jc_name"] ?? "";
              obj["JIO Point Id"] = obj["jio_point_id"] ?? "";
              obj["JIO Point Name"] = obj["jio_point_name"] ?? "";
              obj["Retailer Id"] = obj["retailer_id"] ?? "";
              obj["Retailer Name"] = obj["retailer_name"] ?? "";
              obj["POS Agent Id"] = obj["pos_agent_Code"] ?? "";
              obj["POS AGENT NAME"] = obj["pos_agent_Name"] ?? "";
              obj["POS AGENT ROLE TYPE ID"] =
                obj["pos_agent_role_type_code"] ?? "";
              obj["POS AGENT ROLE TYPE NAME"] =
                obj["pos_agent_role_type_name"] ?? "";
              obj["JPR TYPE NAME"] = obj["jpr_type_name"] ?? "";
              delete obj["jc_id"];
              delete obj["jc_name"];
              delete obj["jio_point_id"];
              delete obj["jio_point_name"];
              delete obj["retailer_id"];
              delete obj["retailer_name"];
              delete obj["pos_agent_Code"];
              delete obj["pos_agent_Name"];
              delete obj["pos_agent_role_type_code"];
              delete obj["pos_agent_role_type_name"];
              delete obj["jpr_type_code"];
              delete obj["jpr_type_name"];
              return obj;
            });
          return csv;
        },
        last: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC ID"] = obj["jc_id"] ?? "";
              obj["JC Name"] = obj["jc_name"] ?? "";
              obj["JIO Point Id"] = obj["jio_point_id"] ?? "";
              obj["JIO Point Name"] = obj["jio_point_name"] ?? "";
              obj["Retailer Id"] = obj["retailer_id"] ?? "";
              obj["Retailer Name"] = obj["retailer_name"] ?? "";
              obj["POS Agent Id"] = obj["pos_agent_Code"] ?? "";
              obj["POS AGENT NAME"] = obj["pos_agent_Name"] ?? "";
              obj["POS AGENT ROLE TYPE ID"] =
                obj["pos_agent_role_type_code"] ?? "";
              obj["POS AGENT ROLE TYPE NAME"] =
                obj["pos_agent_role_type_name"] ?? "";
              obj["JPR TYPE NAME"] = obj["jpr_type_name"] ?? "";
              obj["BILLING TYPE"] = obj["billing_type_text"] ?? "";
              obj["MNP"] = obj["mnp_flag"] ?? "";
              obj["OFFER ID"] = obj["offer_code"] ?? "";
              obj["OFFER CATEGORY"] = obj["offer_category"] ?? "";
              obj["QUANTITY"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jc_id"];
              delete obj["jc_name"];
              delete obj["jio_point_id"];
              delete obj["jio_point_name"];
              delete obj["retailer_id"];
              delete obj["retailer_name"];
              delete obj["pos_agent_Code"];
              delete obj["pos_agent_Name"];
              delete obj["pos_agent_role_type_code"];
              delete obj["pos_agent_role_type_name"];
              delete obj["jpr_type_code"];
              delete obj["jpr_type_name"];
              delete obj["billing_type_text"];
              delete obj["mnp_flag"];
              delete obj["offer_code"];
              delete obj["offer_category"];
              delete obj["tar_qt"];
              delete obj["qty"];
              delete obj["ekyc_flag"];
              return obj;
            });
          return csv;
        },
        JIOPHONE: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JP"] = obj["zdCode"] ?? "";
              obj["JP Name"] = obj["zdName"] ?? "";
              obj["JC"] = obj["jcCode"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["RDS"] = obj["rds"] ?? "";
              obj["RDS Name"] = obj["rdsName"] ?? "";
              obj["Retailer"] = obj["retailerId"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
              obj["Billing Type"] = obj["billingType"] ?? "";
              obj["MNP"] = obj["mnp"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgenRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgenRoleTypeName"] ?? "";
              obj["Offer Code"] = obj["offerCode"] ?? "";
              obj["Offer Category"] = obj["offerCategory"] ?? "";
              obj["E-KYC"] = obj["ekycFlag"] ?? "";
              obj["Plan"] = obj["plan"] ?? "";
              obj["Quantity"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zdCode"];
              delete obj["zdName"];
              delete obj["jcCode"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["billingType"];
              delete obj["mnp"];
              delete obj["posAgentCode"];
              delete obj["posAgenRoleTypeCode"];
              delete obj["posAgenRoleTypeName"];
              delete obj["offerCode"];
              delete obj["offerCategory"];
              delete obj["ekycFlag"];
              delete obj["plan"];
              delete obj["qty"];
              delete obj["perAch"];
              delete obj["retailerId"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeName"];
              delete obj["ard"];
              delete obj["ardName"];
              return obj;
            });
          return csv;
        },
      })[tile]();
      return csv;
    },
    JP: () => {
      ({
        sim: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC ID"] = obj["jc_id"] ?? "";
              obj["JC Name"] = obj["jc_name"] ?? "";
              obj["JIO Point Id"] = obj["jio_point_id"] ?? "";
              obj["JIO Point Name"] = obj["jio_point_name"] ?? "";
              obj["Retailer Id"] = obj["retailer_id"] ?? "";
              obj["Retailer Name"] = obj["retailer_name"] ?? "";
              obj["POS Agent Id"] = obj["pos_agent_Code"] ?? "";
              obj["BILLING TYPE"] = obj["billing_type_text"] ?? "";
              obj["MNP"] = obj["mnp_flag"] ?? "";
              obj["OFFER ID"] = obj["offer_code"] ?? "";
              obj["TAR QUANTITY"] = obj["tar_qt"] ?? "";
              obj["QUANTITY"] = obj["qty"] ?? "";
              obj["EKYC FLAG"] = obj["ekyc_flag"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jc_id"];
              delete obj["jc_name"];
              delete obj["jio_point_id"];
              delete obj["jio_point_name"];
              delete obj["retailer_id"];
              delete obj["retailer_name"];
              delete obj["pos_agent_Code"];
              delete obj["pos_agent_Name"];
              delete obj["pos_agent_role_type_code"];
              delete obj["pos_agent_role_type_name"];
              delete obj["jpr_type_code"];
              delete obj["jpr_type_name"];
              delete obj["billing_type_text"];
              delete obj["mnp_flag"];
              delete obj["offer_code"];
              delete obj["offer_category"];
              delete obj["tar_qt"];
              delete obj["qty"];
              delete obj["ekyc_flag"];
              return obj;
            });
        },
        daily: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["JC ID"] = obj["jc_id"] ?? "";
              obj["JC Name"] = obj["jc_name"] ?? "";
              obj["JIO Point Id"] = obj["jio_point_id"] ?? "";
              obj["JIO Point Name"] = obj["jio_point_name"] ?? "";
              obj["Retailer Id"] = obj["retailer_id"] ?? "";
              obj["Retailer Name"] = obj["retailer_name"] ?? "";
              obj["POS Agent Id"] = obj["pos_agent_Code"] ?? "";
              obj["POS AGENT NAME"] = obj["pos_agent_Name"] ?? "";
              obj["POS AGENT ROLE TYPE ID"] =
                obj["pos_agent_role_type_code"] ?? "";
              obj["POS AGENT ROLE TYPE NAME"] =
                obj["pos_agent_role_type_name"] ?? "";
              obj["JPR TYPE NAME"] = obj["jpr_type_name"] ?? "";
              delete obj["jc_id"];
              delete obj["jc_name"];
              delete obj["jio_point_id"];
              delete obj["jio_point_name"];
              delete obj["retailer_id"];
              delete obj["retailer_name"];
              delete obj["pos_agent_Code"];
              delete obj["pos_agent_Name"];
              delete obj["pos_agent_role_type_code"];
              delete obj["pos_agent_role_type_name"];
              delete obj["jpr_type_code"];
              delete obj["jpr_type_name"];
              return obj;
            });
          return csv;
        },
        last: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JC ID"] = obj["jc_id"] ?? "";
              obj["JC Name"] = obj["jc_name"] ?? "";
              obj["JIO Point Id"] = obj["jio_point_id"] ?? "";
              obj["JIO Point Name"] = obj["jio_point_name"] ?? "";
              obj["Retailer Id"] = obj["retailer_id"] ?? "";
              obj["Retailer Name"] = obj["retailer_name"] ?? "";
              obj["POS Agent Id"] = obj["pos_agent_Code"] ?? "";
              obj["POS AGENT NAME"] = obj["pos_agent_Name"] ?? "";
              obj["POS AGENT ROLE TYPE ID"] =
                obj["pos_agent_role_type_code"] ?? "";
              obj["POS AGENT ROLE TYPE NAME"] =
                obj["pos_agent_role_type_name"] ?? "";
              obj["JPR TYPE NAME"] = obj["jpr_type_name"] ?? "";
              obj["BILLING TYPE"] = obj["billing_type_text"] ?? "";
              obj["MNP"] = obj["mnp_flag"] ?? "";
              obj["OFFER ID"] = obj["offer_code"] ?? "";
              obj["OFFER CATEGORY"] = obj["offer_category"] ?? "";
              obj["QUANTITY"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["jc_id"];
              delete obj["jc_name"];
              delete obj["jio_point_id"];
              delete obj["jio_point_name"];
              delete obj["retailer_id"];
              delete obj["retailer_name"];
              delete obj["pos_agent_Code"];
              delete obj["pos_agent_Name"];
              delete obj["pos_agent_role_type_code"];
              delete obj["pos_agent_role_type_name"];
              delete obj["jpr_type_code"];
              delete obj["jpr_type_name"];
              delete obj["billing_type_text"];
              delete obj["mnp_flag"];
              delete obj["offer_code"];
              delete obj["offer_category"];
              delete obj["tar_qt"];
              delete obj["qty"];
              delete obj["ekyc_flag"];
              return obj;
            });
          return csv;
        },
        JIOPHONE: () => {
          csv =
            content &&
            content.map((obj) => {
              obj["Region"] = obj["region"] ?? "";
              obj["State"] = obj["state"] ?? "";
              obj["JP"] = obj["zdCode"] ?? "";
              obj["JP Name"] = obj["zdName"] ?? "";
              obj["JC"] = obj["jcCode"] ?? "";
              obj["JC Name"] = obj["jcName"] ?? "";
              obj["RDS"] = obj["rds"] ?? "";
              obj["RDS Name"] = obj["rdsName"] ?? "";
              obj["Retailer"] = obj["retailerId"] ?? "";
              obj["Retailer Name"] = obj["retailerName"] ?? "";
              obj["JPR Type Name"] = obj["jprTypeName"] ?? "";
              obj["Billing Type"] = obj["billingType"] ?? "";
              obj["MNP"] = obj["mnp"] ?? "";
              obj["POS Agent Code"] = obj["posAgentCode"] ?? "";
              obj["POS Agent Role Type Code"] =
                obj["posAgenRoleTypeCode"] ?? "";
              obj["POS Agent Role Type Name"] =
                obj["posAgenRoleTypeName"] ?? "";
              obj["Offer Code"] = obj["offerCode"] ?? "";
              obj["Offer Category"] = obj["offerCategory"] ?? "";
              obj["E-KYC"] = obj["ekycFlag"] ?? "";
              obj["Plan"] = obj["plan"] ?? "";
              obj["Quantity"] = obj["qty"] ?? "";
              delete obj["region"];
              delete obj["state"];
              delete obj["zdCode"];
              delete obj["zdName"];
              delete obj["jcCode"];
              delete obj["jcName"];
              delete obj["rds"];
              delete obj["rdsName"];
              delete obj["retailer"];
              delete obj["retailerName"];
              delete obj["jprTypeName"];
              delete obj["billingType"];
              delete obj["mnp"];
              delete obj["posAgentCode"];
              delete obj["posAgenRoleTypeCode"];
              delete obj["posAgenRoleTypeName"];
              delete obj["offerCode"];
              delete obj["offerCategory"];
              delete obj["ekycFlag"];
              delete obj["plan"];
              delete obj["qty"];
              delete obj["perAch"];
              delete obj["retailerId"];
              delete obj["posAgentName"];
              delete obj["posAgentRoleTypeName"];
              delete obj["ard"];
              delete obj["ardName"];
              return obj;
            });
          return csv;
        },
      })[tile]();
      return csv;
    },
  })[role]();
  return csv;
};